import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

interface VideoModalProps {
  src: string;
  onClose: () => void;
}

export function VideoModal({ src, onClose }: VideoModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999]"
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-md"
        onClick={onClose}
        style={{ zIndex: 0, animation: "fade-in 0.2s ease-out" }}
      />
      <div
        className="relative w-full max-w-3xl mx-4 rounded-2xl overflow-hidden shadow-2xl shadow-black/30 animate-modal-in"
        style={{ zIndex: 1 }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 p-2 rounded-xl bg-black/30 backdrop-blur-md text-white/80 hover:text-white hover:bg-black/50 transition-all duration-200 border border-white/10"
        >
          <X className="size-5" />
        </button>
        <video
          src={src}
          className="w-full max-h-[50vh]"
          controls
          autoPlay
          loop
          playsInline
        />
      </div>
    </div>,
    document.body,
  );
}
